import Vue from "vue";
import VueI18n from "vue-i18n";
import restrictions from "./restrictions";

Vue.use(VueI18n);

const supportedLocales = {
  en: "English",
  fr: "French",
  de: "German",
  it: "Italian",
  es: "Spanish",
};

const loadLocaleMessages = () => {
  const locales = require.context(
    "@/assets/translations",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  return messages;
};

const supportedLocalesInclude = (locale) => {
  return Object.keys(supportedLocales).includes(locale);
};

const getBrowserLocale = (options = {}) => {
  const defaultOptions = { countryCodeOnly: false };
  const opt = { ...defaultOptions, ...options };
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language;

  if (!navigatorLocale) {
    return undefined;
  }

  const trimmedLocale = opt.countryCodeOnly
    ? navigatorLocale.trim().split(/-|_/)[0]
    : navigatorLocale.trim();

  return trimmedLocale;
};

const getStartingLocale = () => {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true });

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale;
  }

  return process.env.VUE_APP_I18N_LOCALE || "en";
};

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
});
